import { WOW } from 'wowjs';

(function ($) {
    $(document).ready(function () {
        const wow = new WOW({
            animateClass: 'animate__animated',
            offset: 200,
        });

        wow.init();

        /**
         * Copyright - Display current year
         */

        let copyrightYear = new Date().getFullYear();
        $('#copyright-year').text(copyrightYear);

        /**
         * Back to top button - scroll functionality
         */

        let backToTopButton = $('#back-to-top');

        backToTopButton.addClass('fade').on('click', function () {
            $('html, body').animate(
                {
                    scrollTop: 0,
                },
                400
            );
        });

        /**
         * Back to top button - show/hide functionality
         */

        let debounce;

        $(window).on('scroll', function () {
            //clear the delay if it's not finished yet
            if (debounce) clearTimeout(debounce);

            //start a new delay
            debounce = setTimeout(function () {
                //remove reference so another delay can start
                debounce = null;

                // show/hide the button
                if ($(window).scrollTop() > 200) {
                    backToTopButton.addClass('show');
                } else {
                    backToTopButton.removeClass('show');
                }
            }, 200);
        });

        /**
         * carousel block video pause button
         */

        $('.carousel-block a.video-pause-button').click(function () {
            const slideVideo = $(this)
                .closest('.carousel-item')
                .find('video')[0];
            if (slideVideo.paused) {
                slideVideo.play();
            } else {
                slideVideo.pause();
            }

            $(this).toggleClass('paused');
            $(this).toggleClass('playing');
        });

        /**
         * Carousel block - Set equal heights
         */

        equalCarouselSlideHeights('.carousel-block .carousel');

        function equalCarouselSlideHeights(carouselSelector) {
            $(carouselSelector).each(function () {
                var items = $('.carousel-item', this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(this).css('height', '');
                    $('.carousel-caption', this).css('height', '');

                    $(slide).addClass('active');
                });

                // Get the height of the tallest caption and save it
                $.each(items, function () {
                    let caption = $('.carousel-caption', this);
                    let captionHeight = caption.outerHeight();

                    if (captionHeight > maxHeight) {
                        maxHeight = captionHeight;
                    }
                });

                // Apply the max height to all captions
                $.each(items, function () {
                    if (
                        $(window).width() >=
                        parseInt($(':root').css('--breakpoint-lg'))
                    ) {
                        $(this).css('height', maxHeight);
                    } else {
                        $('.carousel-caption', this).css('height', maxHeight);
                    }

                    // Remove .active from all slides
                    $(this).removeClass('active');
                });

                // Add the active class back to the first slide
                $(
                    '.carousel-inner .carousel-item:first-of-type',
                    this
                ).addClass('active');
            });
        }
    });
})(jQuery);
